<template>
  <div class="field">
    <label v-bind:for="name">{{ $t(label) }}</label>
    <input
      ref="innerInput"
      v-bind:value="value"
      v-on:input="handleInput"
      v-bind:id="name"
      v-bind:name="name"
      v-bind:type="type"
      :disabled="disabled"
      :autofocus="autofocus"
      :maxlength="maxLength"
      v-bind:autocomplete="autocomplete"
      v-bind:class="[{ 'is-invalid': errors.has(name)}, inputClass, 'default-text']">
    <div v-if="errors.has(name)" class="invalid-feedback">{{ errors.first(name) }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      name: String,
      label: String,
      inputClass: String,
      type: {
        type: String,
        default: "text",
        validator: val => {
          return (
            ["url", "text", "password", "email", "search"].indexOf(val) !== -1
          );
        }
      },
      autocomplete: {
        type: String,
        default: function () {
          return "off"
        }
      },
      disabled: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      autofocus: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      value: String,
      maxLength: {
        type: Number,
        default: function () {
          return 50
        }
      },
    },
    inject: ['$validator'],
    methods: {
      handleInput(e) {
        // this allow us to use v-model
        this.$emit('input', e.target.value)
      },
      clear() {
        this.$refs.innerInput.value = ""
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/form.scss';

  input {
    width: 100%;
    height: 44px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 3px;
    border: solid 1px $bluish-grey-50;
  }

  input[disabled] {
    background-color: $light-grey;
  }

  input.is-invalid {
    border: solid 1px red;
  }
</style>



// WEBPACK FOOTER //
// src/components/input.vue